import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadDetectionListFailed, loadDetectionListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';

export default function* loadDetectionList(action) {
  try {
    const {
      payload = {
      },
    } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      offset = 0,
      reverse_order: reverseOrder = false,
    } = payload;
    const pool = {
      limit,
      offset,
      reverse_order: reverseOrder,
    };
    const url = `${BACKEND_URL}/journal-data`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadDetectionListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadDetectionListFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadDetectionListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
